export default "__VITE_ASSET__JGwlaR_O__"